export default "__VITE_ASSET__CVlHF4Mc__"